import React, { useEffect, useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import JobBoardDetailsContent from "../../components/jobManagement/JobBoardDetailsContent";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../hooks/useAuth";
import { useNotificationService } from "../../components/notification";
// import { apiGetJobId } from "../../api/jobs";
import { useLocation } from "react-router-dom";
import { getUrlPathId } from "../../utils/url-id";
import {
  JobIdDetailsProps,
  JobIdProps,
  defaultJobDetails,
} from "../../interface/job_board";
import { InputCustom } from "../../components/UIElements/input-ui";
import { apiGetJobId } from "../../api/job";
import BackButton from "../../components/UIElements/BackButton";

const FacilityJobDetails = () => {
  const theme = useTheme();
  const isSmall = useResponsive("down", "sm", "xl");
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();

  const { token } = useAuth();
  const [jobDetails, setJobDetails] =
    useState<JobIdDetailsProps>(defaultJobDetails);
  const [modal_status, setModal_status] = useState("");
  const location = useLocation();

  useEffect(() => {
    const jobId = getUrlPathId(location?.pathname);
    const fields = { jobId: jobId, token: token };
    mutation.mutate(fields);
  }, []);

  const mutation = useMutation({
    mutationFn: (fields: JobIdProps) => apiGetJobId(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        setJobDetails(data.data.data);
        
        setModal_status(data?.data?.data?.status);
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
          <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Job Management
            </Typography>
            
          </Stack>
        </Box>
      </Header>

      <JobBoardDetailsContent  modalStatus={modal_status}
        setModalStatus={setModal_status}
        jobDetails={jobDetails}
        loading={mutation.isPending}
       />
    </>
  );
};

export default FacilityJobDetails;
